import { configureStore } from '@reduxjs/toolkit';
import initialDataReduces from './initialDataSlice';
import pageSliceReducer from "./PageSlice"
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import redRes from "./../DCM/components/Reducer/redRes";
import redRes1 from "./../DCM/components/Reducer/redRes1";
import redRes2 from "./../DCM/components/Reducer/redRes2";

// Redux Persist configuration
const persistConfig = {
  key: 'root',  // Key for localStorage
  storage,      // Default localStorage
};

const persistedInitialDataReducer = persistReducer(persistConfig, initialDataReduces);
const persistedPageSliceReduces = persistReducer(persistConfig, pageSliceReducer);


const rootReducer = combineReducers({
  initialData: persistedInitialDataReducer,
  pageSlice : persistedPageSliceReduces,
  redres: redRes,
  redres1: redRes1,
  redres2: redRes2,
});



export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,  // To avoid errors with non-serializable state
    }),
});

export const persistor = persistStore(store);

export default store;
